export const SHARED_ENDPOINTS = {
    REFRESH_TOKEN: {
        url: process.env.REACT_APP_SERVER_URL + '/refresh-token',
    },
    LOGOUT: {
        url: process.env.REACT_APP_SERVER_URL + '/logout',
    },
};
